export const DEFAULT_LANGUAGE = 'fr';
export const SUPPORTED_LANGUAGES = ['fr', 'en'];
export const LANGUAGE_STORAGE_KEY = 'knowmediq.language';

export const resources = {
  fr: {
    common: {
      loading: 'Chargement...',
      back: 'Retour',
      continue: 'Continuer',
      confirm: 'Confirmer',
      cancel: 'Annuler',
      save: 'Enregistrer',
      edit: 'Modifier',
      close: 'Fermer',
      noneProvided: 'Non fourni',
      noneProvidedFeminine: 'Non fournie',
      noneSpecified: 'Non spécifiée',
      notAvailable: 'Non disponible',
      yes: 'Oui',
      no: 'Non',
      english: 'English',
      french: 'Français',
    },
    nav: {
      providerArea: 'Espace Prestataire',
      clientArea: 'Espace Client',
      home: 'ACCUEIL',
      services: 'PRESTATIONS DE SERVICE +',
      blog: 'BLOG',
      contact: 'CONTACT',
      logout: 'Déconnexion',
      join: 'Rejoindre',
      languageSwitch: 'ENGLISH',
    },
    footer: {
      contactInfo: 'Informations De Contact',
      hours: 'Horaires',
      customerService: 'Service Client',
      booking: 'Prise De RDV',
      social: 'Réseaux Sociaux',
      usefulLinks: 'Liens utiles',
      partnership: 'Partenariat',
      becomeProvider: 'Devenir prestataire',
      rights: 'Tous droits réservés',
      bookingHours: '24/7 - Confirmation en 24 heures',
    },
    home: {
      heroTitle: 'Soins à domicile et services virtuels de santé et de bien-être',
      heroBody: 'Soins de santé personnalisés. Des professionnels certifiés en qui vous pouvez avoir confiance. Service rapide et pratique dans le confort de votre maison.',
      cta: 'Prendre Rendez-vous',
      professionalsCount: '50+ Professionnels',
      whatIs: 'Qu’est-ce que KnowMediQ ?',
      networkTitle: 'Réseau Des Professionnels De La Santé Et Du Bien-Être',
      networkBody: 'KnowMediQ met à votre disposition un réseau de professionnels pour tous vos besoins en matière de soins de santé et de bien-être offerts dans le confort de votre foyer grâce à des consultations en ligne et des services à domicile. Le moyen le plus simple d’accéder à des prestataires de services certifiés et d’obtenir l’aide dont vous avez besoin en un temps record.',
      whyTitle: 'Pourquoi Choisir KnowMediQ ?',
      whyBody: 'Les services de soins à domicile permettent aux personnes de tous âges de recevoir des soins à domicile plutôt que dans un hôpital ou un établissement de soins de longue durée. Les soins à domicile ont été associés à une diminution de la mortalité, à une meilleure qualité de vie, à une réduction des hospitalisations et à une réduction des coûts des soins de santé.',
      whySource: 'Statistique Canada',
      digitalRecordTitle: 'Dossier Médical Numérisé',
      digitalRecordBody: 'Centralisez et suivez vos informations de santé en toute sécurité.',
      onlineBookingTitle: 'Rendez-Vous En Ligne',
      onlineBookingBody: 'Réservez facilement, 24/7, selon vos disponibilités.',
      homeVisitTitle: 'Consultation À Domicile',
      homeVisitBody: 'Des soins personnalisés dans le confort de votre maison.',
      telehealthTitle: 'Consultation En Ligne',
      telehealthBody: 'Téléconsultation sécurisée et pratique avec nos professionnels.',
    },
    login: {
      title: 'Connexion patient',
      button: 'Se connecter avec Cognito',
    },
    payment: {
      title: 'Paiement de {amount} $',
      fullName: 'Nom complet',
      saveCard: 'Garder ma carte pour de futurs paiements',
      creditCard: 'Carte de crédit',
      payNow: 'Payer maintenant',
      guestDataMissing: 'Données invité manquantes',
      fixErrors: 'Merci de corriger les erreurs.',
      alreadyPaid: 'Ce rendez-vous a déjà été payé.',
      paymentConfirmed: 'Paiement confirmé !',
      paymentPending: 'Paiement en cours de traitement...',
      unknownError: 'Erreur inconnue',
      errorPrefix: 'Erreur : ',
      nameRequired: 'Nom requis',
      invalidEmail: 'Email invalide',
      invalidPhone: 'Téléphone invalide (10 chiffres)',
      addressRequired: 'Adresse requise',
    },
    servicesPages: {
      label: 'SERVICES',
      bookCta: 'PRENDRE UN RDV',
      homeCareTitle: 'Services De Soins À Domicile',
      homeCareBody: 'Avec KnowMediQ, accédez à un réseau en expansion de soignants et thérapeutes palliatifs compétents pour une prise en charge complète et personnalisée de vos proches, couvrant des besoins variés allant du court au long terme. Les services offerts vont des soins d’hygiène et la compagnie à la préparation de repas, en passant par le transport et l’administration des médicaments, sans oublier le soutien spécialisé pour des conditions telles que les soins post-hospitalisation, palliatifs, Alzheimer, démence, cancer et autres, garantissant une réponse adaptée à chaque situation spécifique.',
      homeCareCardsTitle: 'Tous Types De Soins',
      homeCareCardsBody: 'Grâce à KnowMediQ, trouvez des soignants et des thérapeutes palliatifs de notre réseau grandissant qui sauront répondre à vos besoins. Assurez-vous facilement que vos proches sont bien pris en charge. Des besoins spontanés, à court terme et à long terme peuvent être demandés.',
      homeCareAidTitle: 'Aide À Domicile',
      homeCareAidBody: 'Un soutien pour les tâches quotidiennes, le soin des personnes et l’assistance spécifique selon les besoins.',
      homeCareNurseTitle: 'Infirmières',
      homeCareNurseBody: 'Des soins médicaux primaires, des suivis de santé et des interventions spécifiques adaptées à vos besoins.',
      homeCareFootTitle: 'Podologues',
      homeCareFootBody: 'Optez pour un podologue pour des soins à domicile, incluant le traitement des ongles, la coupe, le soin des callosités et plus.',
      mentalHealthTitle: 'Services De Santé Mentale',
      mentalHealthBody: 'KnowMediQ, à travers ses prestataires variés, propose une gamme étendue de services de santé mentale destinés à répondre aux divers besoins des clients. Ces services englobent des séances de yoga pour le bien-être physique et mental, du coaching de vie pour la motivation et la gestion des objectifs, des thérapies psychologiques pour traiter les troubles émotionnels et comportementaux, ainsi que du soutien social pour aider à naviguer dans les défis de la vie quotidienne. Cette approche holistique vise à promouvoir l’équilibre et le bien-être mental, offrant aux clients des outils personnalisés pour gérer le stress, l’anxiété et d’autres problèmes de santé mentale dans un cadre soutenant et sécurisé.',
      mentalHealthCardsTitle: 'Tous types de soins',
      mentalHealthCardsBody: 'Avec KnowMediQ, accédez à un réseau diversifié de yogis, coachs de vie, psychothérapeutes et travailleurs sociaux pour des soins de santé mentale adaptés à tous besoins, garantissant bien-être et soutien continu.',
      mentalHealthCoachTitle: 'Coach de vie',
      mentalHealthCoachBody: 'Connectez avec des coachs de vie pour un accompagnement vers vos objectifs personnels et professionnels.',
      mentalHealthTherapyTitle: 'Psychothérapeutes Et Travailleurs Sociaux',
      mentalHealthTherapyBody: 'KnowMediQ vous relie à des travailleurs sociaux pour un soutien mental et social adapté à vos besoins spécifiques.',
      wellnessTitle: 'Services De Bien-Être',
      wellnessBody: 'KnowMediQ propose une gamme complète de services de bien-être grâce à ses prestataires qualifiés, incluant des massothérapeutes pour la détente musculaire et la réduction du stress, des physiothérapeutes pour la rééducation et l’amélioration de la mobilité, des nutritionnistes pour des conseils alimentaires personnalisés visant une santé optimale, et des formateurs pour des programmes d’exercices sur mesure destinés à renforcer le corps et l’esprit. Chaque professionnel s’engage à fournir des soins personnalisés et adaptés, assurant une approche holistique du bien-être adaptée aux besoins individuels de chaque client.',
      wellnessCardsTitle: 'Tous Types De Soins',
      wellnessCardsBody: 'Avec KnowMediQ, accédez à des massothérapeutes, physiothérapeutes, nutritionnistes et formateurs de notre réseau pour des soins de bien-être personnalisés, répondant à tout besoin, du spontané au long terme.',
      wellnessMassageTitle: 'Massothérapeute',
      wellnessMassageBody: 'KnowMediQ connecte avec des massothérapeutes pour des massages personnalisés, couvrant relaxation, reiki, shiatsu et plus, pour votre bien-être.',
      wellnessTrainerTitle: 'Entraîneurs Privés',
      wellnessTrainerBody: 'Nous vous mettons en relation avec des entraîneurs privés pour atteindre vos objectifs de forme, de la perte de poids au renforcement musculaire.',
      wellnessNutritionTitle: 'Nutritionniste',
      wellnessNutritionBody: 'Trouvez des nutritionnistes agréés pour des plans alimentaires sur mesure, incluant perte de poids, sport, santé familiale et gestion de maladies.',
      bloodTestsTitle: 'Analyses de sang',
      bloodTestsBody: 'Grâce à KnowMediQ, trouvez du personnel de laboratoire et des infirmières agréés de notre réseau en expansion pour vos besoins en échantillons de sang. La vitesse est la clé. Obtenez vos résultats dans les 24 heures et envoyez-les directement à votre médecin de famille sur demande. La prestation peut comprendre des prélèvements sanguins, des prélèvements d’urine, une prise de sang complète, des analyses de laboratoire, des ECG, des tests d’allergies, des IST, des tests génétiques, des tests prénatals et des tests d’hyperglycémie provoquée. Chaque prestataire propose des services personnalisés et les demandes spécifiques doivent être clairement décrites pour garantir des soins appropriés. Si nécessaire, veuillez contacter KnowMediQ pour des questions et une assistance supplémentaire.',
      bloodTestsCardsTitle: 'Tous Types De Soins',
      bloodTestsCardsBody: 'KnowMediQ propose des prestations mobiles pour vos besoins en analyses : tests sanguins, ECG, tests spécialisés et communication rapide avec les professionnels de santé.',
      bloodTestsSamplingTitle: 'Prélèvements',
      bloodTestsSamplingBody: 'Tests de sang, d’urine, analyses IST, prénatales, génétiques ou d’allergies à domicile.',
      bloodTestsEcgTitle: 'Tests ECG et Glycémie',
      bloodTestsEcgBody: 'Réalisation d’ECG, tests d’hyperglycémie provoquée et autres mesures de santé spécifiques.',
      bloodTestsResultsTitle: 'Résultats en 24h',
      bloodTestsResultsBody: 'Résultats envoyés à votre médecin de famille en 24 heures via notre réseau de laboratoires agréés.',
      pharmacyComingSoonTitle: 'Service À Venir',
      pharmacyComingSoonBody: 'Ce service sera bientôt disponible.',
      pharmacyTitle: 'Livraison De Médicaments',
      pharmacyBody1: 'Grâce à KnowMediQ, trouvez des pharmacies livrant non seulement vos ordonnances à domicile d’un simple clic, mais également tous les médicaments en vente libre. Les vaccins contre la grippe, le COVID-19 et le zona sont offerts, et bien plus encore.',
      pharmacyBody2: 'Le service peut inclure une évaluation physique, des tests de santé, des prescriptions de médicaments et la livraison de médicaments en vente libre.',
      pharmacyBody3: 'Chaque prestataire offre des services personnalisés. Pour toute question, contactez KnowMediQ.',
      pharmacyCta: 'TROUVEZ VOTRE PHARMACIEN',
    },
    booking: {
      takeAppointment: 'Prendre un rendez-vous',
      findProfessional: 'Trouvez un professionnel de santé en fonction de vos besoins.',
      chooseSpeciality: 'Choisir une spécialité',
      chooseService: 'Sélectionnez un service',
      viewAvailability: 'Voir les disponibilités',
      noProfessionals: 'Aucun professionnel trouvé pour cette spécialité.',
      chooseSpecialityPrompt: 'Veuillez choisir une spécialité.',
      speciality: 'Spécialité',
      coveredZone: 'Zone couverte',
      viewProfile: 'Voir le profil',
      bookNow: 'Prendre rendez-vous',
      appointmentDate: 'Date du rendez-vous',
      appointmentTime: 'Heure du rendez-vous',
      professional: 'Professionnel',
      service: 'Service',
      name: 'Nom',
      reserveSlot: 'Réserver un créneau',
      lastName: 'Nom',
      firstName: 'Prénom',
      email: 'Email',
      phone: 'Téléphone',
      address: 'Adresse',
      postalCode: 'Code postal',
      birthDate: 'Date de naissance',
      notes: 'Notes spéciales',
      notesPlaceholder: 'Notes spéciales (ex : allergies, préférences...)',
      createAccount: 'Créer un compte',
      continueAsGuest: 'Continuer en tant qu\'invité',
      summary: 'Récapitulatif',
      noNotes: 'Aucune',
      payAndConfirm: 'Payer et confirmer',
      editInformation: 'Modifier les informations',
      missingService: 'Veuillez sélectionner un service avant de continuer.',
      invalidPostalCode: 'Le code postal n’est pas valide. Exemple valide : H1A 2B3',
      missingIdentity: 'Merci de remplir le nom, prénom et email.',
      bookingError: 'Erreur lors de la réservation. Vérifie les champs ou réessaie plus tard.',
      appointmentConfirmed: 'Rendez-vous confirmé !',
      thanksPayment: 'Merci pour votre paiement. Voici les détails :',
      mode: 'Mode',
      inPerson: 'En personne',
      virtual: 'En ligne',
      returnHome: 'Retour à l’accueil',
      viewAppointments: 'Voir mes rendez-vous',
      noAppointmentData: 'Aucune donnée de rendez-vous',
      amountToPay: 'Montant à payer',
      patientInfo: 'Informations du patient',
      proceedToPayment: 'Procéder au paiement',
      emailNotVerified: 'Votre adresse email n\'est pas encore vérifiée.',
      confirmationSent: 'Un lien de confirmation vous a été envoyé à',
      checkInbox: 'Merci de vérifier votre boîte mail et cliquer sur le lien de confirmation.',
      emailVerified: 'Email vérifié avec succès !',
      missingParameters: 'Paramètres manquants. Veuillez revenir à l’étape précédente.',
    },
  },
  en: {
    common: {
      loading: 'Loading...',
      back: 'Back',
      continue: 'Continue',
      confirm: 'Confirm',
      cancel: 'Cancel',
      save: 'Save',
      edit: 'Edit',
      close: 'Close',
      noneProvided: 'Not provided',
      noneProvidedFeminine: 'Not provided',
      noneSpecified: 'Not specified',
      notAvailable: 'Not available',
      yes: 'Yes',
      no: 'No',
      english: 'English',
      french: 'French',
    },
    nav: {
      providerArea: 'Provider Portal',
      clientArea: 'Client Portal',
      home: 'HOME',
      services: 'SERVICES +',
      blog: 'BLOG',
      contact: 'CONTACT',
      logout: 'Log out',
      join: 'Join',
      languageSwitch: 'FRANÇAIS',
    },
    footer: {
      contactInfo: 'Contact Information',
      hours: 'Hours',
      customerService: 'Customer Service',
      booking: 'Booking',
      social: 'Social Media',
      usefulLinks: 'Useful Links',
      partnership: 'Partnerships',
      becomeProvider: 'Become a provider',
      rights: 'All rights reserved',
      bookingHours: '24/7 - Confirmation within 24 hours',
    },
    home: {
      heroTitle: 'In-home care and virtual health and wellness services',
      heroBody: 'Personalized healthcare from certified professionals you can trust. Fast, convenient service in the comfort of your home.',
      cta: 'Book an Appointment',
      professionalsCount: '50+ Professionals',
      whatIs: 'What is KnowMediQ?',
      networkTitle: 'A Network of Health and Wellness Professionals',
      networkBody: 'KnowMediQ gives you access to a network of professionals for your health and wellness needs through online consultations and at-home services. It is the simplest way to reach certified providers and get the help you need quickly.',
      whyTitle: 'Why Choose KnowMediQ?',
      whyBody: 'Home care services allow people of all ages to receive care at home instead of in a hospital or long-term care facility. Home care is associated with lower mortality, better quality of life, fewer hospitalizations, and lower healthcare costs.',
      whySource: 'Statistics Canada',
      digitalRecordTitle: 'Digital Medical Record',
      digitalRecordBody: 'Centralize and track your health information securely.',
      onlineBookingTitle: 'Online Appointments',
      onlineBookingBody: 'Book easily, 24/7, based on your availability.',
      homeVisitTitle: 'Home Visits',
      homeVisitBody: 'Personalized care in the comfort of your home.',
      telehealthTitle: 'Online Consultation',
      telehealthBody: 'Secure, convenient telehealth with our professionals.',
    },
    login: {
      title: 'Patient sign in',
      button: 'Sign in with Cognito',
    },
    payment: {
      title: 'Payment of {amount} $',
      fullName: 'Full name',
      saveCard: 'Save my card for future payments',
      creditCard: 'Credit card',
      payNow: 'Pay now',
      guestDataMissing: 'Missing guest booking data',
      fixErrors: 'Please fix the errors.',
      alreadyPaid: 'This appointment has already been paid.',
      paymentConfirmed: 'Payment confirmed!',
      paymentPending: 'Payment is still processing...',
      unknownError: 'Unknown error',
      errorPrefix: 'Error: ',
      nameRequired: 'Name is required',
      invalidEmail: 'Invalid email',
      invalidPhone: 'Invalid phone number (10 digits)',
      addressRequired: 'Address is required',
    },
    servicesPages: {
      label: 'SERVICES',
      bookCta: 'BOOK NOW',
      homeCareTitle: 'Home Care Services',
      homeCareBody: 'With KnowMediQ, access a growing network of skilled caregivers and palliative therapists for comprehensive, personalized support for your loved ones, from short-term to long-term needs. Services range from hygiene care and companionship to meal preparation, transportation, medication administration, and specialized support for post-hospital care, palliative needs, Alzheimer’s, dementia, cancer, and more.',
      homeCareCardsTitle: 'All Types of Care',
      homeCareCardsBody: 'Through KnowMediQ, find caregivers and palliative therapists in our growing network who can meet your needs. Make sure your loved ones are well cared for, whether the need is immediate, short term, or long term.',
      homeCareAidTitle: 'Home Support',
      homeCareAidBody: 'Support for daily tasks, personal care, and specialized assistance based on individual needs.',
      homeCareNurseTitle: 'Nurses',
      homeCareNurseBody: 'Primary medical care, follow-ups, and targeted interventions tailored to your needs.',
      homeCareFootTitle: 'Foot Care Specialists',
      homeCareFootBody: 'Choose a foot care specialist for in-home care, including nail treatment, trimming, callus care, and more.',
      mentalHealthTitle: 'Mental Health Services',
      mentalHealthBody: 'KnowMediQ offers a broad range of mental health services through its provider network. These include yoga sessions for physical and mental wellbeing, life coaching for motivation and goal-setting, psychological therapies for emotional and behavioral challenges, and social support to help navigate daily life. This holistic approach promotes balance and mental wellbeing with personalized tools in a supportive, secure setting.',
      mentalHealthCardsTitle: 'All Types of Care',
      mentalHealthCardsBody: 'With KnowMediQ, access a diverse network of yogis, life coaches, psychotherapists, and social workers for mental health support tailored to every need.',
      mentalHealthCoachTitle: 'Life Coach',
      mentalHealthCoachBody: 'Connect with life coaches for guidance toward your personal and professional goals.',
      mentalHealthTherapyTitle: 'Psychotherapists and Social Workers',
      mentalHealthTherapyBody: 'KnowMediQ connects you with social workers for mental and social support tailored to your needs.',
      wellnessTitle: 'Wellness Services',
      wellnessBody: 'KnowMediQ offers a full range of wellness services through qualified providers, including massage therapists for muscle relief and stress reduction, physiotherapists for rehabilitation and mobility, nutritionists for personalized nutrition guidance, and trainers for customized exercise programs that strengthen body and mind.',
      wellnessCardsTitle: 'All Types of Care',
      wellnessCardsBody: 'With KnowMediQ, access massage therapists, physiotherapists, nutritionists, and trainers in our network for personalized wellness care, from spontaneous needs to ongoing support.',
      wellnessMassageTitle: 'Massage Therapist',
      wellnessMassageBody: 'KnowMediQ connects you with massage therapists for personalized treatments, including relaxation, reiki, shiatsu, and more.',
      wellnessTrainerTitle: 'Personal Trainers',
      wellnessTrainerBody: 'We connect you with personal trainers to help you meet your fitness goals, from weight loss to strength building.',
      wellnessNutritionTitle: 'Nutritionist',
      wellnessNutritionBody: 'Find licensed nutritionists for tailored meal plans supporting weight loss, sport, family health, and chronic condition management.',
      bloodTestsTitle: 'Blood Tests',
      bloodTestsBody: 'Through KnowMediQ, find licensed lab staff and nurses in our growing network for your blood sample needs. Speed matters. Receive your results within 24 hours and have them sent directly to your family doctor on request. Services can include blood draws, urine samples, full blood work, lab analysis, ECGs, allergy testing, STI screening, genetic testing, prenatal testing, and glucose tolerance testing. Each provider offers personalized services, and specific requests should be clearly described to ensure the right care.',
      bloodTestsCardsTitle: 'All Types of Care',
      bloodTestsCardsBody: 'KnowMediQ offers mobile services for your testing needs: bloodwork, ECGs, specialized tests, and fast communication with healthcare professionals.',
      bloodTestsSamplingTitle: 'Sample Collection',
      bloodTestsSamplingBody: 'At-home blood, urine, STI, prenatal, genetic, and allergy testing.',
      bloodTestsEcgTitle: 'ECG and Glucose Testing',
      bloodTestsEcgBody: 'ECGs, glucose tolerance testing, and other targeted health measurements.',
      bloodTestsResultsTitle: 'Results in 24h',
      bloodTestsResultsBody: 'Results sent to your family physician within 24 hours through our licensed lab network.',
      pharmacyComingSoonTitle: 'Service coming soon',
      pharmacyComingSoonBody: 'This service will be available soon.',
      pharmacyTitle: 'Medication Delivery',
      pharmacyBody1: 'Through KnowMediQ, find pharmacies that deliver your prescriptions to your home with a click, along with over-the-counter medication. Flu, COVID-19, and shingles vaccines are also available, and more.',
      pharmacyBody2: 'This service may include physical assessments, health tests, medication prescriptions, and over-the-counter medication delivery.',
      pharmacyBody3: 'Each provider offers personalized services. Contact KnowMediQ if you have any questions.',
      pharmacyCta: 'FIND YOUR PHARMACIST',
    },
    booking: {
      takeAppointment: 'Book an appointment',
      findProfessional: 'Find a healthcare professional based on your needs.',
      chooseSpeciality: 'Choose a specialty',
      chooseService: 'Select a service',
      viewAvailability: 'View availability',
      noProfessionals: 'No professionals were found for this specialty.',
      chooseSpecialityPrompt: 'Please choose a specialty.',
      speciality: 'Specialty',
      coveredZone: 'Coverage area',
      viewProfile: 'View profile',
      bookNow: 'Book now',
      appointmentDate: 'Appointment date',
      appointmentTime: 'Appointment time',
      professional: 'Professional',
      service: 'Service',
      name: 'Name',
      reserveSlot: 'Reserve a time slot',
      lastName: 'Last name',
      firstName: 'First name',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      postalCode: 'Postal code',
      birthDate: 'Date of birth',
      notes: 'Special notes',
      notesPlaceholder: 'Special notes (for example allergies or preferences)',
      createAccount: 'Create an account',
      continueAsGuest: 'Continue as guest',
      summary: 'Summary',
      noNotes: 'None',
      payAndConfirm: 'Pay and confirm',
      editInformation: 'Edit information',
      missingService: 'Please select a service before continuing.',
      invalidPostalCode: 'The postal code is not valid. Valid example: H1A 2B3',
      missingIdentity: 'Please fill in your first name, last name, and email.',
      bookingError: 'There was an error while booking. Please check the form or try again later.',
      appointmentConfirmed: 'Appointment confirmed!',
      thanksPayment: 'Thank you for your payment. Here are the details:',
      mode: 'Mode',
      inPerson: 'In person',
      virtual: 'Online',
      returnHome: 'Back to home',
      viewAppointments: 'View my appointments',
      noAppointmentData: 'No appointment data found',
      amountToPay: 'Amount due',
      patientInfo: 'Patient information',
      proceedToPayment: 'Proceed to payment',
      emailNotVerified: 'Your email address has not been verified yet.',
      confirmationSent: 'A confirmation link has been sent to',
      checkInbox: 'Please check your inbox and click the confirmation link.',
      emailVerified: 'Email verified successfully!',
      missingParameters: 'Missing parameters. Please return to the previous step.',
    },
  },
};
